'use strict';

angular.module('ClinicApp').directive('profilePatientNotifications', function($q, ClinicService, OCModalUtil) {
  return {
    scope: {
      profile: '=profilePatientNotifications',
      modelType: '=',
    },
    templateUrl: '/views/directives/_profile-patient-notifications.html',
    link: function($scope) {
      if (['clinic'].indexOf($scope.modelType) == -1) {
        throw new Error('DirectiveArgumentError: `profileSettings` invalid modelType: ' + $scope.modelType + '.');
      }
      $scope.profile.notificationSettings = $scope.profile.notificationSettings || {};

      // Used to set empty dictionaries to true by default
      _.each(['reminders', 'confirmation'], function(reminderType) {
        $scope.profile.notificationSettings[reminderType] = $scope.profile.notificationSettings[reminderType] !== false;
      });

      $scope.toggleNotificationSettings = function(key) {
        if ($scope.modelType == 'clinic') {
          $q.when().then(function() {
            if (!$scope.profile.notificationSettings[key]) {
              return $q.when();
            }
            var confirmText;
            if (key == 'reminders') {
              confirmText = `Are you sure you want to disable appointment reminder notifications for ${$scope.profile.name}? Turning this off will disable any emails or SMS messages sent to patients to remind them about their appointments.`;
            } else if (key == 'confirmation') {
              confirmText = `Are you sure you want to disable appointment time confirmation notifications for ${$scope.profile.name}? Turning this off will disable any emails or SMS messages sent to patients when appointments are scheduled in Opencare.`;
            }
            return OCModalUtil.showModal(
              'confirm',
              confirmText,
            );
          })
            .then(function() {
              $scope.profile.notificationSettings[key] = !$scope.profile.notificationSettings[key];
              ClinicService.updateClinic($scope.profile, {
                notificationSettings: $scope.profile.notificationSettings,
              }).then(function() {
                $scope.$emit('reloadClinic');
              });
            });
        }
      };
    },
  };
});
